<template>
    <footer class="footer-area">
        <div class="divider"></div>
        <div class="container">
            <div class="row">
                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="single-footer-widget">
                        <div class="logo">
                            <router-link to="/"><img src="../../assets/img/benovium_logo_black.png" alt="image" style="height: 25vh"></router-link>
                        </div>
                        <p>Benovium ist Ihr zuverlässiger Partner für innovative IT-Lösungen. Wir unterstützen Sie bei der digitalen Transformation und entwickeln maßgeschneiderte Software für Ihr Unternehmen.</p>
                    </div>
                </div>

                <div class="col-lg-2 col-md-6 col-sm-6">
                    <div class="single-footer-widget">
                        <h3>Unternehmen</h3>

                        <ul class="services-list">
                            <li><router-link to="/about">Über uns</router-link></li>
                            <li><router-link to="/services/webentwicklung">Webentwicklung</router-link></li>
                            <li><router-link to="/services/seo">SEO-Optimierung</router-link></li>
                            <li><router-link to="/services/betreuung">Betreuung</router-link></li>
                            <li><router-link to="/services/it-beratung">IT-Beratung</router-link></li>
                        </ul>
                    </div>
                </div>
                
                <div class="col-lg-2 col-md-6 col-sm-6">
                    <div class="single-footer-widget">
                        <h3>Support</h3>
                        
                        <ul class="support-list">
                            <li><router-link to="/faq">FAQ</router-link></li>
                            <li><router-link to="/referenzen">Referenzen</router-link></li>
                            <li><router-link to="/contact">Kontakt</router-link></li>
                        </ul>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="single-footer-widget">
                        <h3>Kontaktdaten</h3>

                        <ul class="footer-contact-info">
                            <li>Standort: <a href="https://maps.google.com/?q=Antonigasse+44/5,+1180+Wien" target="_blank">Antonigasse 44/5, 1180 Wien</a></li>
                            <li>E-Mail: <a href="mailto:office@benovium.com">office@benovium.com</a></li>
                            <li>Telefon: <a href="tel:+436605782160">+43 660 578 2160</a></li>
                        </ul>
                        <!-- <ul class="social">
                            <li><a href="https://www.facebook.com/" target="_blank"><i class="bx bxl-facebook"></i></a></li>
                            <li><a href="https://twitter.com/" target="_blank"><i class="bx bxl-twitter"></i></a></li>
                            <li><a href="https://www.linkedin.com/" target="_blank"><i class="bx bxl-linkedin"></i></a></li>
                            <li><a href="https://www.instagram.com/" target="_blank"><i class="bx bxl-instagram"></i></a></li>
                        </ul> -->
                    </div>
                </div>
            </div>

            <div class="copyright-area">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-6">
                        <p>&copy; Benovium e.U. {{ new Date().getFullYear() }} - Alle Rechte vorbehalten</p>
                    </div>
                    <div class="col-lg-6 col-md-6">
                        <ul class="legal-links">
                            <li><router-link to="/impressum">Impressum</router-link></li>
                            <li><router-link to="/datenschutz">Datenschutz</router-link></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'FooterStyleOne',
}
</script>